import type { HelpFile } from '../../types/help'
import { ApprovalPolicyEditTestIds } from '../../../testids/ApprovalPolicyEditTestIds'

export const approvalPolicyEditHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyEditTestIds.approvalPolicyEditPage]: 'Eine bestehende Genehmigungsrichtlinie bearbeiten — Geltungsbereich, Genehmigerkette und Eskalationsregeln für passende Zugriffsanträge anpassen.',
  },
}
